import { TranslatedText } from "@/components/common/text";
import { cn } from "@/utils/css";

export const PredictionChartButton = ({ option, setActiveValue, activeValue, disabled }) => {
    return (
        <button
            className={cn("min-w-[41px] h-[36px] px-3 py-2 rounded-[58px] transition-colors duration-200 text-cm-p-text-primary ", {
                "bg-cm-p-surface-container": activeValue === option.value,
                "bg-transparent": activeValue !== option.value,
            })}
            onClick={() => setActiveValue(option.value)}
            disabled={disabled}
        >
            <TranslatedText>{option.name}</TranslatedText>
        </button>
    );
};
